import React from 'react'
import {
  Layout,
  Card,
  Col,
  Row,
  Button,
  Divider,
  Checkbox,
  InputNumber,
  Modal,
  Spin,
  message,
  Typography
} from 'antd'
import Skeleton from 'react-loading-skeleton'
import {
  AlignCenterOutlined,
  CloseOutlined,
  CheckOutlined,
  CaretDownOutlined,
  DollarCircleOutlined
} from '@ant-design/icons'
import axios from 'axios'
import DataServices from '../../Services/DataServices'
import IntlMessages from '../../util/IntlMessages'
import { connect } from 'react-redux'
import Iframe from 'react-iframe'
import {
  loadPaymentTypesModalShow,
  loadShowContactUs
} from '../../appRedux/actions/CommonData'
import PaymentTypesModal from '../../components/Payments/PaymentTypesModal'
import PaymentStatusModal from '../../components/Payments/PaymentStatusModal'
import moment from 'moment'
import EnterpriceImg from '../../../src/assets/images/product-details.png'
import checklistitemsImg from '../../../src/assets/images/checklist-items.png'
import ContactUsDialog from '../../components/ContactUsDialog'
import {
  // REACT_APP_BUS_FIRST_NAME,
  // REACT_APP_BUS_NAME,
  PAY_PAY_MODE
} from '../../constants/StoreSetting'
import CheckLoginCredentials from '../../components/CheckLoginCredentials'
import BuzzTillBannerLogo from '../../assets/images/BUZZTILL_logo_500px.png'
import { env } from '../../env'
import { checkIsWeb, postDataToApp } from '../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../constants/MobAppConstants'
import SubscriptionPlans from './SubscriptionPlans'

const { REACT_APP_BUS_FIRST_NAME, REACT_APP_BUS_NAME } = env
const { Meta } = Card
let perMonth = 120
let changePerMonth
const gridStyle = {
  width: '25%',
  textAlign: 'center'
}
const { Title, Text, Link } = Typography

class BillingPlans extends React.Component {
  constructor (props) {
    const { tokenLess } =
      props.match && props.match.params ? props.match.params : props
    super()
    this.updatedSubscriptionPlan = this.updatedSubscriptionPlan.bind(this)
    this.updatedPlanBill = this.updatedPlanBill.bind(this)
    this.updatedOutlet = this.updatedOutlet.bind(this)
    this.updatedRegister = this.updatedRegister.bind(this)
    this.BillingCalculations = this.BillingCalculations.bind(this)
    this.getUserSubscription = this.getUserSubscription.bind(this)
    this.componentWillMount = this.componentWillMount.bind(this)
    this.state = {
      statistics: null,
      getSubscriptionS: [],
      getSub: [],
      isSelectedPlan: 2, //default is 2
      isSelectedBill: 2, //default is 2
      billTypeName: '',
      outletCount: '',
      outletPriceYearlyPerMonth: '',
      outletPricePerMonth: '',
      planName: '',
      registerCount: 1,
      registerYearlyPricePerMonth: '',
      registerPricePerMonth: '',
      totalBill: '',
      totalBillWithTax: '',
      billTypeName: '',
      packageId: 2, //default is 2
      fixedoutletPriceYearlyPerMonth: '',
      fixedoutletPricePerMonth: '',
      fixedegisterYearlyPricePerMonth: '',
      fixedregisterPricePerMonth: '',
      billType: 'Annualy',
      locale: 'en',
      showPaymentDropdown: false, // Open IsOpen
      selectedPaymentOption: null,
      paymentOption: '',
      visible: false,
      isBillingLoading: false,
      getLinkUrl: '',
      paymentTypes: [],
      paymentGateway: '',
      isScreenLoading: true,
      assignOutlets: 1,
      assignRegisters: 1,
      paidAmount: 0,
      paidCurrency: '',
      paidIsMonthly: false,
      subEndDate: '',
      selectedPkgCurrSymbol: '',
      isDisableLiteBasic: false,
      isWithoutToken: tokenLess ? true : false,
      countries: [],
      bTypes: [],
      isFreeTrial: false,
      api_data: {}
    }
  }
  setBillingType = type => {
    this.setState({ billTypeName: type })
  }
  setPackageID = id => {
    this.setState({ packageId: id })
  }
  setOutlet = count => {
    this.setState({ outletCount: count })
  }
  setRegister = count => {
    this.setState({ registerCount: count })
  }
  callingSubscriptionData = () => {
    var results = DataServices.getSubscription(this.state.isWithoutToken)
      .then(data => {
        if (data.data) {
          this.setState({ api_data: data.data.data })
          if (data.data.data && data.data.data.isTrialFree) {
            this.setState({ isFreeTrial: data.data.data.isTrialFree })
          }
          this.setState({ getSubscriptionS: data.data.data.packages })
          data.data.data.packages.map((packages, i) => {
            if (packages.isRecommended) {
              //for Lite
              if (packages.packageID == 2) {
                this.setState({ isSelectedPlan: 1 })
              }
              //For Pro
              else if (packages.packageID == 3) {
                this.setState({ isSelectedPlan: 2 })
              }
              // this.setState({ outletCount: packages.nbrOfOutletFrom })
              this.setOutlet(packages.nbrOfOutletFrom)
              this.setState({ outletCountTo: packages.nbrOfOutletTo })
              // this.setState({ billTypeName: 'Annually' }) // We also send bill type by default from db
              this.setBillingType('Annually')
              this.setState({
                outletPriceYearlyPerMonth: packages.priceYearlyMo
              })
              this.setState({ planName: packages.packageTitle })
              // this.setState({ registerCount: 1 })
              this.setRegister(1)
              this.setState({
                registerYearlyPricePerMonth: packages.regPriceYearlyMo
              })
              this.setState({
                totalBill: parseInt(packages.priceYearlyMo) * 12
              }) //price year muliply 12 because by default we calculate year
              this.setState({ outletPricePerMonth: packages.pricePerMo })
              // this.setState({ packageId: packages.packageID })
              this.setPackageID(packages.packageID)
              this.setState({ registerPricePerMonth: packages.regPricePerMo })
              this.setState({
                fixedoutletPriceYearlyPerMonth: packages.priceYearlyMo
              })
              this.setState({ fixedoutletPricePerMonth: packages.pricePerMo })
              this.setState({
                fixedegisterYearlyPricePerMonth: packages.regPriceYearlyMo
              })
              this.setState({
                fixedregisterPricePerMonth: packages.regPricePerMo
              })
              this.setState({
                fixedregisterPricePerMonth: packages.regPricePerMo
              })
            }
          })

          // outlet & reg curr (because the default selected plan is the second plan)
          if (data.data.data.packages.length > 2) {
            this.setState({
              selectedPkgCurrSymbol: data.data.data.packages[1].currencySymbol
            })
          }

          //if store includes more than 1 outlet then disabled basic plan
          if (data.data.data.storeInfo.storeOutlets > 1) {
            this.setState({
              isDisableLiteBasic: true
            })
          } else {
            this.setState({
              isDisableLiteBasic: false
            })
          }

          //countries
          if (
            //  this.state.isWithoutToken &&
            data.data.data.countriesOptions.length > 0
          ) {
            this.setState({ countries: data.data.data.countriesOptions })
          }
          //busines types
          if (
            //  this.state.isWithoutToken &&
            data.data.data.businessOptions.length > 0
          ) {
            this.setState({ bTypes: data.data.data.businessOptions })
          }
        }
        this.setState({ isScreenLoading: false })
      })
      .catch(e => {
        this.setState({ isScreenLoading: false })
      })
  }
  componentWillMount () {
    this.callingSubscriptionData()
    if (!this.state.isWithoutToken) {
      this.getUserSubscription()
    }
    if (!checkIsWeb().exist) {
      postDataToApp(PostAppTypes.PAGE_HEADER, 'retail.billing.title')
    }
    // this.getPaymentTypesService();
  }
  componentDidUpdate () {
    // console.log(this.props.locale);
    if (this.state.locale != this.props.locale) {
      //console.log('value changed')
      this.setState({ locale: this.props.locale })
      this.callingSubscriptionData()
      this.getUserSubscription()
    }
  }

  updatedSubscriptionPlan (packageId) {
    if (packageId == 2) {
      this.setState({ isSelectedPlan: 1 })
    } else if (packageId == 3) {
      this.setState({ isSelectedPlan: 2 })
    } else if (packageId == 4) {
      this.setState({ isSelectedPlan: 3 })
    }

    // this.setState({ packageId: packageId })
    this.setPackageID(packageId)

    this.state.getSubscriptionS.map(packages => {
      if (packages.packageID == packageId) {
        // this.setState({ outletCount: packages.nbrOfOutletFrom })
        this.setOutlet(packages.nbrOfOutletFrom)
        this.setState({ planName: packages.packageTitle })

        this.setState({
          fixedoutletPriceYearlyPerMonth: packages.priceYearlyMo
        })
        this.setState({ fixedoutletPricePerMonth: packages.pricePerMo })
        this.setState({
          fixedegisterYearlyPricePerMonth: packages.regPriceYearlyMo
        })
        this.setState({ fixedregisterPricePerMonth: packages.regPricePerMo })
        this.setState({ outletCountTo: packages.nbrOfOutletTo })

        this.setState({
          outletPriceYearlyPerMonth:
            packages.priceYearlyMo * packages.nbrOfOutletFrom
        })
        this.setState({
          outletPricePerMonth: packages.pricePerMo * packages.nbrOfOutletFrom
        })
        this.setState({
          registerYearlyPricePerMonth:
            packages.regPriceYearlyMo *
            (this.state.registerCount - packages.nbrOfOutletFrom)
        })
        this.setState({
          registerPricePerMonth:
            packages.regPricePerMo *
            (this.state.registerCount - packages.nbrOfOutletFrom)
        })

        if (this.state.billTypeName == 'Monthly') {
          if (packages.nbrOfOutletFrom < this.state.registerCount) {
            this.setState({
              totalBill:
                packages.pricePerMo * packages.nbrOfOutletFrom +
                packages.regPricePerMo *
                  (this.state.registerCount - packages.nbrOfOutletFrom)
            })
          } else {
            this.setState({
              totalBill: packages.pricePerMo * packages.nbrOfOutletFrom
            })
          }
        } else if (this.state.billTypeName == 'Annually') {
          if (packages.nbrOfOutletFrom < this.state.registerCount) {
            this.setState({
              totalBill:
                (packages.priceYearlyMo * packages.nbrOfOutletFrom +
                  packages.regPriceYearlyMo *
                    (this.state.registerCount - packages.nbrOfOutletFrom)) *
                12
            })
          } else {
            this.setState({
              totalBill: packages.priceYearlyMo * packages.nbrOfOutletFrom * 12
            })
          }
        }
      }
    })

    this.BillingCalculations()
  }

  updatedPlanBill (planType) {
    this.setState({ isSelectedBill: planType })
    if (planType == 1) {
      // this.setState({ billTypeName: 'Monthly' })
      this.setBillingType('Monthly')
      this.setState({ billType: 'Monthly' })
      if (this.state.outletCount < this.state.registerCount) {
        this.setState({
          totalBill:
            this.state.outletPricePerMonth + this.state.registerPricePerMonth
        })
      } else {
        this.setState({ totalBill: this.state.outletPricePerMonth })
      }
    } else if (planType == 2) {
      // this.setState({ billTypeName: 'Annually' })
      this.setBillingType('Annually')
      this.setState({ billType: 'Annualy' })
      if (this.state.outletCount < this.state.registerCount) {
        this.setState({
          totalBill:
            this.state.outletPriceYearlyPerMonth * 12 +
            this.state.registerYearlyPricePerMonth * 12
        })
      } else {
        this.setState({ totalBill: this.state.outletPriceYearlyPerMonth * 12 })
      }
    }

    this.BillingCalculations()
  }

  updatedOutlet (outletCount) {
    if (this.state.outletCountTo == '+') {
      this.state.getSubscriptionS.map(packages => {
        if (packages.packageID == this.state.packageId) {
          this.setState({
            outletPriceYearlyPerMonth: packages.priceYearlyMo * outletCount
          })
          this.setState({
            outletPricePerMonth: packages.pricePerMo * outletCount
          })
          this.setState({
            registerYearlyPricePerMonth:
              packages.regPriceYearlyMo *
              (this.state.registerCount - outletCount)
          })
          this.setState({
            registerPricePerMonth:
              packages.regPricePerMo * (this.state.registerCount - outletCount)
          })

          if (this.state.billTypeName == 'Monthly') {
            if (outletCount < this.state.registerCount) {
              this.setState({
                totalBill:
                  packages.pricePerMo * outletCount +
                  packages.regPricePerMo *
                    (this.state.registerCount - outletCount)
              })
            } else {
              this.setState({ totalBill: packages.pricePerMo * outletCount })
            }
          } else if (this.state.billTypeName == 'Annually') {
            if (outletCount < this.state.registerCount) {
              this.setState({
                totalBill:
                  packages.priceYearlyMo * outletCount * 12 +
                  packages.regPriceYearlyMo *
                    (this.state.registerCount - outletCount) *
                    12
              })
            } else {
              this.setState({
                totalBill: packages.priceYearlyMo * outletCount * 12
              })
            }
          }
        }
      })
      if (outletCount > this.state.registerCount) {
        this.setRegister(outletCount)
      }
      // this.setState({ outletCount: outletCount })
      this.setOutlet(outletCount)
    } else {
      // this.setState({ outletCount: 1 })
      this.setOutlet(1)
    }
    this.BillingCalculations()
  }

  updatedRegister (registerCount) {
    this.state.getSubscriptionS.map(packages => {
      if (packages.packageID == this.state.packageId) {
        this.setState({
          outletPriceYearlyPerMonth:
            packages.priceYearlyMo * this.state.outletCount
        })
        this.setState({
          outletPricePerMonth: packages.pricePerMo * this.state.outletCount
        })
        this.setState({
          registerYearlyPricePerMonth:
            packages.regPriceYearlyMo * (registerCount - this.state.outletCount)
        })
        this.setState({
          registerPricePerMonth:
            packages.regPricePerMo * (registerCount - this.state.outletCount)
        })

        if (this.state.billTypeName == 'Monthly') {
          if (this.state.outletCount < registerCount) {
            this.setState({
              totalBill:
                packages.pricePerMo * this.state.outletCount +
                packages.regPricePerMo *
                  (registerCount - this.state.outletCount)
            })
          } else {
            this.setState({
              totalBill: packages.pricePerMo * this.state.outletCount
            })
          }
        } else if (this.state.billTypeName == 'Annually') {
          if (this.state.outletCount < registerCount) {
            this.setState({
              totalBill:
                packages.priceYearlyMo * this.state.outletCount * 12 +
                packages.regPriceYearlyMo *
                  (registerCount - this.state.outletCount) *
                  12
            })
          } else {
            this.setState({
              totalBill: packages.priceYearlyMo * this.state.outletCount * 12
            })
          }
        }
      }
    })
    // this.setState({ registerCount: registerCount })
    this.setRegister(registerCount)
    this.BillingCalculations()
  }

  BillingCalculations () {}

  async getUserSubscription () {
    const createReq = DataServices.getUserSubscriptionService()
    await createReq
      .then(res => {
        if (res) {
          localStorage.setItem('subscriptionExpiresOn', res.subEndDate)
          let dateEnd = ''
          let currency = ''
          if (res.subEndDate) {
            dateEnd = new Date(res.subEndDate)
            dateEnd = dateEnd.toLocaleDateString()
          }
          if (res.amountPaidCurrency) {
            currency =
              res.amountPaidCurrency == '978' ? 'EUR' : res.amountPaidCurrency
          }
          this.setState({
            assignOutlets: res.noOfOutlet ? res.noOfOutlet : 1,
            assignRegisters: res.noOfRegister ? res.noOfRegister : 1,
            paidAmount: res.totalAmountPaid ? res.totalAmountPaid : 0,
            paidCurrency: currency,
            paidIsMonthly: res.isMonthly,
            subEndDate: dateEnd
          })
        }
      })
      .catch(e => {
        //   console.error("createSubPayment", e);
        //   this.setState({
        //     isBillingLoading: false,
        //   });
        //   message.error("Failed, report this & Try later");
      })
  }

  render () {
    //sub date exp check
    var subLeftDays
    var subDescription
    var subAvailable

    function parseDate (str) {
      var mdy = str.split('/')
      return new Date(mdy[2], mdy[0] - 1, mdy[1])
    }
    function dateDiff (first, second) {
      return Math.round((second - first) / (1000 * 60 * 60 * 24))
    }
    ;(() => {
      // let expiresOn = localStorage.getItem("subscriptionExpiresOn");
      // let subEndsOn = new Date(Date.parse(expiresOn)).toLocaleDateString();
      // let currDate = new Date().toLocaleDateString();
      // let daysLeft = dateDiff(parseDate(currDate), parseDate(subEndsOn));

      const expiresOn = localStorage.getItem('subscriptionExpiresOn')
      const subEndsOn = moment(expiresOn)
      const currDate = moment()
      const daysLeft = dateDiff(currDate, subEndsOn)
      if (daysLeft > 0) {
        subAvailable = true
        if (daysLeft == 1) {
          subLeftDays = this.state.isWithoutToken ? (
            `You have ${daysLeft} left on your Subscription.`
          ) : (
            <IntlMessages
              id='dashboard.dashboard.activateaccount'
              description='Activate account message'
              defaultMessage='You have <strong>{subLeftDays} days</strong> left on your Subscription.'
              values={{
                strong: chunks => <strong>{chunks}</strong>,
                subLeftDays: daysLeft
              }}
            />
          )
        } else {
          subLeftDays = this.state.isWithoutToken ? (
            `You have ${daysLeft} left on your Subscription.`
          ) : (
            <IntlMessages
              id='dashboard.dashboard.activateaccount'
              description='Activate account message'
              defaultMessage='You have <strong>{subLeftDays} days</strong> left on your Subscription.'
              values={{
                strong: chunks => <strong>{chunks}</strong>,
                subLeftDays: daysLeft
              }}
            />
          )
        }
        subDescription =
          daysLeft > 14 ? (
            this.state.isWithoutToken ? (
              `You may continue to explore and use your store, or follow the steps below to set up a new package for your store now.`
            ) : (
              <IntlMessages id='dashboard.billingplans.continueexplorenewpackage' />
            )
          ) : this.state.isWithoutToken ? (
            ``
          ) : (
            <IntlMessages id='Your subscription is about to expire, you may continue to use store, or follow the steps below to set up new subscription for your store' />
          )
      } else {
        subAvailable = false
        subLeftDays = this.state.isWithoutToken ? (
          `Continue your retail journey with ${REACT_APP_BUS_NAME}`
        ) : (
          <IntlMessages
            id='dashboard.billingplans.continueexploreretailJourney'
            values={{
              strong: chunks => <strong>{chunks}</strong>,
              bus_name_first: REACT_APP_BUS_FIRST_NAME
            }}
          />
        )
        subDescription = this.state.isWithoutToken ? (
          `Your subscription has expired. Follow the steps below to set up your own store now.`
        ) : (
          <IntlMessages id='dashboard.billingplans.continueexploreexpire' />
        )
      }
    })()

    const abc =
      this.state.getSubscriptionS != [] &&
      this.state.getSubscriptionS.map((item, index) => {})

    return (
      <div className='Content-wrapper'>
        {this.state.isWithoutToken && <CheckLoginCredentials />}
        <Spin
          tip={
            this.state.isWithoutToken ? (
              `Loading`
            ) : (
              <IntlMessages id='sell.cashlisting.cashloading' />
            )
          }
          spinning={this.state.isScreenLoading}
          size='large'
        >
          <Row className='d-flex align-items-center justify-content-center mt-3 mb-3 RegisterClosureSummary-header'>
            <Col lg={20} md={20} sm={20} xs={24}>
              <h2 class='mb-0 text-center-md'>
                {this.state.isWithoutToken ? (
                  `SELECT A PLAN TO GET THE BEST OUT OF BUZZTILL POINT OF SALE SYSTEM`
                ) : (
                  <IntlMessages
                    id='dashboard.billingplans.selectplanbestdakar'
                    values={{
                      strong: chunks => <strong>{chunks}</strong>,
                      bus_name_first: REACT_APP_BUS_FIRST_NAME
                    }}
                  />
                )}
              </h2>
            </Col>

            <Col lg={4} md={4} sm={4} xs={24}>
              <div className='plain-logo'>
                <img alt='' src={BuzzTillBannerLogo} />
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={24} md={24} sm={24} xs={24}>
              {!this.state.isWithoutToken && (
                <Card
                  className='gx-card border-10-imp'
                  title={<p className='mb-0 left-days'>{subLeftDays}</p>}
                >
                  {subAvailable && (
                    <div className='gx-main-content'>
                      <Row>
                        <Col span={24}>
                          <Card
                            className='dk-billing-card'
                            title={
                              <h3 className='dk-billing-card-store pl-3'>
                                {this.state.isWithoutToken ? (
                                  `YOUR STORE HAVE`
                                ) : (
                                  <IntlMessages id='dashboard.billingplans.yourstorehave' />
                                )}
                              </h3>
                            }
                          >
                            <Card.Grid
                              className='dk-text-one-line dk-billing-card-pd'
                              hoverable={false}
                            >
                              <strong>
                                {this.state.isWithoutToken ? (
                                  `Paid Amount:`
                                ) : (
                                  <IntlMessages id='dashboard.billingplans.amountoaid' />
                                )}
                              </strong>
                            </Card.Grid>{' '}
                            <Card.Grid
                              hoverable={false}
                              className='dk-billing-card-pd'
                            >
                              {`${this.state.paidAmount} ${this.state.paidCurrency}`}
                            </Card.Grid>
                            <Card.Grid
                              className='dk-text-one-line dk-billing-card-pd'
                              hoverable={false}
                            >
                              <strong>
                                {this.state.isWithoutToken ? (
                                  `Subscription Period:`
                                ) : (
                                  <IntlMessages id='dashboard.billingplans.subsreq' />
                                )}
                              </strong>
                            </Card.Grid>{' '}
                            <Card.Grid
                              hoverable={false}
                              className='dk-billing-card-pd'
                            >
                              {this.state.paidIsMonthly == true ? (
                                this.state.isWithoutToken ? (
                                  `MONTHLY`
                                ) : (
                                  <IntlMessages id='dashboard.billingplans.monthperiod' />
                                )
                              ) : this.state.isWithoutToken ? (
                                `ANNUALLY`
                              ) : (
                                <IntlMessages id='dashboard.billingplans.annualperiod' />
                              )}
                            </Card.Grid>
                            <Card.Grid
                              className='dk-text-one-line dk-billing-card-pd'
                              hoverable={false}
                            >
                              <strong>
                                {this.state.isWithoutToken ? (
                                  `Subscription End Date:`
                                ) : (
                                  <IntlMessages id='dashboard.billingplans.subenddate' />
                                )}
                              </strong>
                            </Card.Grid>{' '}
                            <Card.Grid
                              hoverable={false}
                              className='dk-billing-card-pd'
                            >
                              {this.state.subEndDate}
                            </Card.Grid>
                            <Card.Grid
                              className='dk-text-one-line dk-billing-card-pd'
                              hoverable={false}
                            >
                              <strong>
                                {this.state.isWithoutToken ? (
                                  `Number of Outlets:`
                                ) : (
                                  <IntlMessages id='dashboard.billingplans.assignoutlets' />
                                )}
                              </strong>
                            </Card.Grid>{' '}
                            <Card.Grid
                              hoverable={false}
                              className='dk-billing-card-pd'
                            >
                              {this.state.assignOutlets}
                            </Card.Grid>
                            <Card.Grid
                              className='dk-text-one-line dk-billing-card-pd'
                              hoverable={false}
                            >
                              <strong>
                                {this.state.isWithoutToken ? (
                                  `Number of Registers:`
                                ) : (
                                  <IntlMessages id='dashboard.billingplans.assignregisters' />
                                )}
                              </strong>
                            </Card.Grid>{' '}
                            <Card.Grid
                              hoverable={false}
                              className='dk-billing-card-pd'
                            >
                              {this.state.assignRegisters}
                            </Card.Grid>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  )}

                  <p className='mb-0'>{subDescription}</p>
                </Card>
              )}

              <Divider className='mt-3 mb-4' />

              {this.state.isWithoutToken ? (
                <SubscriptionPlans
                  packageData={this.state.api_data}
                  setPeriod={this.updatedPlanBill}
                  // billingType={this.state.billTypeName}
                  // setPackage={this.setPackageID}
                  setOutlet={this.setOutlet}
                  setRegister={this.setRegister}
                  period={this.state.isSelectedBill}
                  isFreeTrial={this.state.isFreeTrial}
                  outletCount={this.state.outletCount}
                  registerCount={this.state.registerCount}
                />
              ) : (
                <>
                  <Row className='SelectPlan-div'>
                    <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                      <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                        <span>
                          {this.state.isWithoutToken ? (
                            `Select Plan`
                          ) : (
                            <IntlMessages id='dashboard.billingplans.selectplan' />
                          )}
                        </span>
                      </h2>
                    </Col>

                    <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                      <div className='page-container plan-page-container mb-3'>
                        {this.state.getSubscriptionS.map((packages, i) => {
                          if (i == 0) {
                            return (
                              <div
                                style={{
                                  cursor: this.state.isDisableLiteBasic
                                    ? 'default'
                                    : 'pointer'
                                }}
                                data-packageid={packages.packageID}
                                className={`pricing-table div-cursor-pointer ${
                                  this.state.isSelectedPlan == 1 &&
                                  !this.state.isDisableLiteBasic
                                    ? 'pricing-table-highlighted'
                                    : ''
                                } `}
                                onClick={() => {
                                  this.updatedSubscriptionPlan(
                                    packages.packageID
                                  )
                                  this.setState({
                                    selectedPkgCurrSymbol:
                                      packages.currencySymbol
                                  })
                                }}
                              >
                                {packages.isRecommended ? (
                                  <div className='pricing-table-recommend'>
                                    <span>
                                      {this.state.isWithoutToken ? (
                                        `Recommend`
                                      ) : (
                                        <IntlMessages id='dashboard.billingplans.recommend' />
                                      )}
                                    </span>
                                  </div>
                                ) : (
                                  ''
                                )}

                                <div className='pricing-table-header'>
                                  <h2>{packages.packageTitle}</h2>
                                  <p>{packages.packageDescription}</p>
                                </div>
                                <div className='pricing-table-space'></div>
                                <div className='pricing-table-features'>
                                  <p>
                                    <strong>
                                      {' '}
                                      {packages.packageDetails[0]}
                                    </strong>
                                  </p>
                                  <div className='priceplan-lineheight'>
                                    <p>{packages.packageDetails[1]}</p>
                                    <p style={{ fontSize: '12px' }}>
                                      {' '}
                                      {packages.packageDetails[2]}
                                    </p>
                                  </div>
                                </div>
                                <div className='pricing-table-price'>
                                  <p>{packages.packageDetails[3]}</p>
                                </div>

                                <div className='pricing-table-features'>
                                  <ul className='pricing-list-type m-0'>
                                    {packages.packageDetails.map((a, key) => {
                                      if (key > 3) {
                                        return <li key={key}>{a}</li>
                                      }
                                    })}
                                    {/* <li>{packages.packageDetails[4]}</li>
                                    <li>{packages.packageDetails[5]}</li>
                                    <li>{packages.packageDetails[6]}</li>
                                    <li>{packages.packageDetails[7]}</li> */}
                                  </ul>
                                </div>

                                <div className='pricing-table-features-bottom'>
                                  <div className='pricing-table-space'></div>
                                  <div className='pricing-table-features'>
                                    <Divider />
                                    <h2 className='mb-0'>
                                      {packages.currencySymbol}
                                      {this.state.billTypeName == 'Annually'
                                        ? packages.priceYearlyMo
                                        : packages.pricePerMo}
                                      /mo
                                    </h2>
                                    <Divider />

                                    <p>
                                      {this.state.isWithoutToken ? (
                                        `EUR billed`
                                      ) : this.state.isWithoutToken ? (
                                        `EUR billed`
                                      ) : (
                                        <IntlMessages id='dashboard.billingplans.usdbilled' />
                                      )}{' '}
                                      {this.state.billTypeName}
                                    </p>

                                    <p className='billing-plan-selected'>
                                      {' '}
                                      <CheckOutlined />
                                      {this.state.isWithoutToken ? (
                                        `Plan Selected`
                                      ) : (
                                        <IntlMessages id='dashboard.billingplans.planselected' />
                                      )}
                                    </p>
                                  </div>

                                  <div className='pricingtbl-restricted-feature'>
                                    <p> You won't get:</p>
                                    <ul className='pricing-list-type-cross'>
                                      {this.state.getSubscriptionS[0].wontGetDetails.map(
                                        details => {
                                          return (
                                            <li>
                                              <CloseOutlined
                                                style={{ color: '#cc2e2e9e' }}
                                                width='12px'
                                                className='icon-size-close-antd'
                                              />
                                              {details}
                                            </li>
                                          )
                                        }
                                      )}
                                    </ul>
                                  </div>

                                  <div className='pricing-table-features'>
                                    <Button
                                      // className="custom-btn-pricing"
                                      type='primary'
                                      block
                                      disabled={this.state.isDisableLiteBasic}
                                    >
                                      {packages.actionTitle}
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                          if (i == 1) {
                            return (
                              <div
                                data-packageid={packages.packageID}
                                className={`pricing-table div-cursor-pointer ${
                                  this.state.isSelectedPlan == 2
                                    ? 'pricing-table-highlighted'
                                    : ''
                                }`}
                                onClick={() => {
                                  this.updatedSubscriptionPlan(
                                    packages.packageID
                                  )
                                  this.setState({
                                    selectedPkgCurrSymbol:
                                      packages.currencySymbol
                                  })
                                }}
                              >
                                {packages.isRecommended ? (
                                  <div className='pricing-table-recommend'>
                                    <span>
                                      {this.state.isWithoutToken ? (
                                        `Recommend`
                                      ) : (
                                        <IntlMessages id='dashboard.billingplans.recommend' />
                                      )}
                                    </span>
                                  </div>
                                ) : (
                                  ''
                                )}

                                <div className='pricing-table-header'>
                                  <h2>{packages.packageTitle}</h2>
                                  <p>{packages.packageDescription}</p>
                                </div>
                                <div className='pricing-table-space'></div>

                                <div className='pricing-table-features'>
                                  <p>
                                    <strong>
                                      {packages.packageDetails[0]}
                                    </strong>
                                  </p>

                                  <div className='priceplan-lineheight'>
                                    <p>{packages.packageDetails[1]}</p>
                                    <p style={{ fontSize: '12px' }}>
                                      {packages.packageDetails[2]}
                                    </p>
                                  </div>
                                </div>

                                <div className='pricing-table-price'>
                                  <p>{packages.packageDetails[3]}</p>
                                </div>

                                <div className='pricing-table-features'>
                                  <ul className='pricing-list-type m-0'>
                                    {packages.packageDetails.map((a, key) => {
                                      if (key > 3) {
                                        return <li key={key}>{a}</li>
                                      }
                                    })}
                                    {/* <li>{packages.packageDetails[4]}</li>

                                    <li>{packages.packageDetails[5]}</li>
                                    <li>{packages.packageDetails[6]}</li>
                                    <li>{packages.packageDetails[7]}</li>
                                    <li>{packages.packageDetails[8]}</li>
                                    <li>{packages.packageDetails[9]}</li>
                                    <li>{packages.packageDetails[10]}</li>
                                    <li>{packages.packageDetails[11]}</li> */}
                                  </ul>
                                </div>

                                <div className='pricing-table-features-bottom'>
                                  <div className='pricing-table-space'></div>
                                  <div className='pricing-table-features'>
                                    <Divider />
                                    <h2 className='mb-0'>
                                      {packages.currencySymbol}
                                      {this.state.billTypeName == 'Annually'
                                        ? packages.priceYearlyMo
                                        : packages.pricePerMo}
                                      /mo
                                    </h2>
                                    <Divider />
                                    <h3>
                                      {this.state.isWithoutToken ? (
                                        `Per Outlet`
                                      ) : (
                                        <IntlMessages id='dashboard.billingplans.peroutlet' />
                                      )}
                                    </h3>
                                    <p>
                                      {this.state.isWithoutToken ? (
                                        `EUR billed`
                                      ) : (
                                        <IntlMessages id='dashboard.billingplans.usdbilled' />
                                      )}{' '}
                                      {this.state.billTypeName}
                                    </p>

                                    <p className='billing-plan-selected'>
                                      {' '}
                                      <CheckOutlined />
                                      {this.state.isWithoutToken ? (
                                        `Plan Selected`
                                      ) : (
                                        <IntlMessages id='dashboard.billingplans.planselected' />
                                      )}
                                    </p>
                                  </div>

                                  <div className='pricing-table-features'>
                                    <Button
                                      // className="custom-btn-pricing"
                                      type='primary'
                                      onClick={() =>
                                        this.setState({
                                          selectedPkgCurrSymbol:
                                            packages.currencySymbol
                                        })
                                      }
                                      block
                                    >
                                      {packages.actionTitle}
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                          if (i == 2) {
                            return (
                              <div
                                style={{
                                  cursor: this.state.isDisableLiteBasic
                                    ? 'default'
                                    : 'pointer'
                                }}
                                data-packageid={packages.packageID}
                                className={`pricing-table div-cursor-pointer mb-3 ${
                                  this.state.isSelectedPlan == 3
                                    ? 'pricing-table-highlighted'
                                    : ''
                                } `}
                                onClick={() => {
                                  this.updatedSubscriptionPlan(
                                    packages.packageID
                                  )
                                  this.setState({
                                    selectedPkgCurrSymbol:
                                      packages.currencySymbol
                                  })
                                }}
                                // className='pricing-table '
                              >
                                <div className='pricing-table-header'>
                                  <h2>{packages.packageTitle}</h2>
                                  <p>{packages.packageDescription}</p>
                                </div>
                                <div className='pricing-table-space'></div>
                                <div className='pricing-table-features'>
                                  <p>
                                    <strong>
                                      {packages.packageDetails[0]}
                                    </strong>
                                  </p>
                                  <img
                                    className='pro-img-2'
                                    src={EnterpriceImg}
                                  ></img>
                                </div>

                                <div className='pricing-table-features pricing-border-top'>
                                  <ul className='pricing-list-type m-0'>
                                    {packages.packageDetails.map((a, key) => {
                                      if (key > 0) {
                                        return <li key={key}>{a}</li>
                                      }
                                    })}
                                    {/* <li>{packages.packageDetails[2]}</li>
                                    <li>{packages.packageDetails[4]}</li>
                                    <li>{packages.packageDetails[5]}</li> */}
                                  </ul>
                                </div>

                                {/* <div className='pricing-table-features-bottom'>
                                  <div className='pricing-table-space'></div>
                                  <div className='pricing-table-features'>
                                    <h3 className='mb-0'>
                                      {packages.packageDetails[3]}
                                    </h3>
                                  </div>
                                  <div className='pricing-table-features'>
                                    <Button
                                      // className="custom-btn-pricing"
                                      type='primary'
                                      block
                                      onClick={() => {
                                        const { dispatch } = this.props
                                        dispatch(loadShowContactUs(true))
                                        this.setState({
                                          selectedPkgCurrSymbol:
                                            packages.currencySymbol
                                        })
                                      }}
                                    >
                                      {packages.actionTitle}
                                    </Button>
                                  </div>
                                </div> */}
                                <div className='pricing-table-features-bottom'>
                                  <div className='pricing-table-space'></div>
                                  <div className='pricing-table-features'>
                                    <Divider />
                                    <h2 className='mb-0'>
                                      {packages.currencySymbol}
                                      {this.state.billTypeName == 'Annually'
                                        ? packages.priceYearlyMo
                                        : packages.pricePerMo}
                                      /mo
                                    </h2>
                                    <Divider />
                                    <h3>
                                      {this.state.isWithoutToken ? (
                                        `Per Outlet`
                                      ) : (
                                        <IntlMessages id='dashboard.billingplans.peroutlet' />
                                      )}
                                    </h3>
                                    <p>
                                      {this.state.isWithoutToken ? (
                                        `EUR billed`
                                      ) : (
                                        <IntlMessages id='dashboard.billingplans.usdbilled' />
                                      )}{' '}
                                      {this.state.billTypeName}
                                    </p>

                                    <p className='billing-plan-selected'>
                                      {' '}
                                      <CheckOutlined />
                                      {this.state.isWithoutToken ? (
                                        `Plan Selected`
                                      ) : (
                                        <IntlMessages id='dashboard.billingplans.planselected' />
                                      )}
                                    </p>
                                  </div>

                                  <div className='pricing-table-features'>
                                    <Button
                                      // className="custom-btn-pricing"
                                      type='primary'
                                      onClick={() =>
                                        this.setState({
                                          selectedPkgCurrSymbol:
                                            packages.currencySymbol
                                        })
                                      }
                                      block
                                    >
                                      {packages.actionTitle}
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        })}
                      </div>
                    </Col>
                  </Row>

                  <Divider className='mt-3 mb-4' />

                  <Row className='Licenses-div'>
                    <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                      <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                        {this.state.isWithoutToken ? (
                          `Licenses`
                        ) : (
                          <IntlMessages id='dashboard.billingplans.licenses' />
                        )}
                      </h2>
                      <p class='dk-font-size-15'>
                        {this.state.isWithoutToken ? (
                          `Buy licenses for Outlets and Registers to be able to set them up.Listed prices are exclusive of tax.`
                        ) : (
                          <IntlMessages id='dashboard.billingplans.licensesdescp' />
                        )}
                      </p>
                    </Col>

                    <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                      <div className='Licenses-card-wrapper'>
                        <Card
                          className='gx-card mb-0 Licenses-card'
                          title={
                            this.state.isWithoutToken ? (
                              `Outlets`
                            ) : (
                              <IntlMessages id='dashboard.billingplans.outlets' />
                            )
                          }
                        >
                          <div className='Licenses-grp'>
                            <InputNumber
                              type='number'
                              id='outlet-counter'
                              className=''
                              min={1}
                              max={500}
                              defaultValue={1}
                              value={this.state.outletCount}
                              onChange={this.updatedOutlet}
                            />
                            <div className='Licenses-Wrapper'>
                              <div className='Licenses-Billing'>
                                <span style={{ float: 'left' }}>
                                  {this.state.selectedPkgCurrSymbol}
                                </span>
                                <span style={{ fontSize: '21px' }}>
                                  {this.state.billTypeName == 'Monthly'
                                    ? this.state.outletPricePerMonth
                                    : this.state.outletPriceYearlyPerMonth}
                                </span>
                                <span style={{ fontSize: '12px' }}>
                                  {this.state.isWithoutToken ? (
                                    `/mo`
                                  ) : (
                                    <IntlMessages id='dashboard.billingplans.permo' />
                                  )}
                                </span>
                              </div>
                              <div className='Disclamer-text'>
                                <span>
                                  1 @ {this.state.selectedPkgCurrSymbol}
                                  {this.state.billTypeName == 'Monthly'
                                    ? this.state.fixedoutletPricePerMonth
                                    : this.state.fixedoutletPriceYearlyPerMonth}
                                  {this.state.isWithoutToken ? (
                                    `/mo`
                                  ) : (
                                    <IntlMessages id='dashboard.billingplans.permo' />
                                  )}{' '}
                                  ({this.state.planName}{' '}
                                  {this.state.isWithoutToken ? (
                                    `plan`
                                  ) : (
                                    <IntlMessages id='common.resource.plan' />
                                  )}
                                  )
                                </span>
                                <br />
                                {this.state.outletCount != 1 ? (
                                  <span>
                                    {' '}
                                    {this.state.outletCount - 1} @{' '}
                                    {this.state.selectedPkgCurrSymbol}
                                    {this.state.billTypeName == 'Monthly'
                                      ? this.state.fixedoutletPricePerMonth
                                      : this.state
                                          .fixedoutletPriceYearlyPerMonth}
                                    {this.state.isWithoutToken ? (
                                      `/mo`
                                    ) : (
                                      <IntlMessages id='dashboard.billingplans.permo' />
                                    )}{' '}
                                    {this.state.isWithoutToken ? (
                                      `each`
                                    ) : (
                                      <IntlMessages id='common.resource.each' />
                                    )}
                                  </span>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                        </Card>

                        <span className='card-plus'>+</span>

                        <Card
                          className='gx-card mb-0 Licenses-card'
                          title={
                            this.state.isWithoutToken ? (
                              `Registers`
                            ) : (
                              <IntlMessages id='dashboard.billingplans.registers' />
                            )
                          }
                        >
                          <div className='Licenses-grp'>
                            <InputNumber
                              type='number'
                              className=''
                              min={this.state.outletCount}
                              max={2000}
                              value={this.state.registerCount}
                              onChange={this.updatedRegister}
                            />
                            <div className='Licenses-Wrapper'>
                              <div className='Licenses-Billing'>
                                <span style={{ float: 'left' }}>
                                  {this.state.selectedPkgCurrSymbol}
                                </span>
                                <span style={{ fontSize: '21px' }}>
                                  {this.state.outletCount <
                                  this.state.registerCount
                                    ? this.state.billTypeName == 'Monthly'
                                      ? this.state.registerPricePerMonth
                                      : this.state.registerYearlyPricePerMonth
                                    : 0}
                                </span>
                                <span style={{ fontSize: '12px' }}>
                                  {this.state.isWithoutToken ? (
                                    `/mo`
                                  ) : (
                                    <IntlMessages id='dashboard.billingplans.permo' />
                                  )}{' '}
                                </span>
                              </div>
                              <div className='Disclamer-text'>
                                <span>
                                  {this.state.outletCount}{' '}
                                  {this.state.isWithoutToken ? (
                                    `free registers`
                                  ) : (
                                    <IntlMessages id='dashboard.billingplans.freeregisters' />
                                  )}
                                </span>
                                <br />
                                {this.state.outletCount <
                                this.state.registerCount ? (
                                  <span>
                                    {' '}
                                    {this.state.registerCount -
                                      this.state.outletCount}{' '}
                                    @ {this.state.selectedPkgCurrSymbol}
                                    {this.state.billTypeName == 'Monthly'
                                      ? this.state.fixedoutletPricePerMonth
                                      : this.state
                                          .fixedegisterYearlyPricePerMonth}
                                    {this.state.isWithoutToken ? (
                                      `/mo`
                                    ) : (
                                      <IntlMessages id='dashboard.billingplans.permo' />
                                    )}{' '}
                                    {this.state.isWithoutToken ? (
                                      `each`
                                    ) : (
                                      <IntlMessages id='common.resource.each' />
                                    )}{' '}
                                  </span>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                        </Card>
                      </div>
                    </Col>
                  </Row>

                  <Divider className='mt-4 mb-4' />

                  <Row className='Billing-div'>
                    <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                      <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                        {this.state.isWithoutToken ? (
                          `Billing`
                        ) : (
                          <IntlMessages id='dashboard.billingplans.billing' />
                        )}
                      </h2>
                    </Col>

                    <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                      <p>
                        {this.state.isWithoutToken ? (
                          `How do you want to be billed?`
                        ) : (
                          <IntlMessages id='dashboard.billingplans.billingques' />
                        )}
                      </p>

                      <Row className='dk-flex-promo'>
                        <Col
                          lg={12}
                          md={12}
                          sm={12}
                          xs={24}
                          className='dk-flex-promo-1'
                        >
                          <div className='dk-custom-promoadd-card1 dk-flex-promo-1'>
                            <Card
                              title={
                                this.state.isWithoutToken ? (
                                  `Annual Billing`
                                ) : (
                                  <IntlMessages id='dashboard.billingplans.annualbilling' />
                                )
                              }
                              style={{
                                textAlign: 'left',
                                display: 'grid'
                              }}
                              className={`${
                                this.state.isSelectedBill == 2
                                  ? 'ant-card-bordered-active'
                                  : ''
                              }`}
                              onClick={() => this.updatedPlanBill(2)}
                            >
                              <Row>
                                <Col md={12}>
                                  <p style={{ fontSize: '13px' }}>
                                    {this.state.isWithoutToken ? (
                                      `Get your bill once a year and save €360 each year.`
                                    ) : (
                                      <IntlMessages id='dashboard.dashboard.saveeachyear' />
                                    )}
                                  </p>
                                </Col>
                                <Col md={12}>
                                  <h2>
                                    {this.state.selectedPkgCurrSymbol}{' '}
                                    {this.state.outletCount <
                                    this.state.registerCount
                                      ? this.state.outletPriceYearlyPerMonth +
                                        this.state.registerYearlyPricePerMonth
                                      : this.state.outletPriceYearlyPerMonth}
                                    /mo
                                  </h2>
                                  <p>
                                    {' '}
                                    {this.state.isWithoutToken ? (
                                      ` EUR Billed Annually`
                                    ) : (
                                      <IntlMessages id='dashboard.billingplans.usdbillannually' />
                                    )}
                                  </p>
                                  <p
                                    style={{
                                      whiteSpace: 'nowrap',
                                      fontSize: '11px'
                                    }}
                                  >
                                    {this.state.isWithoutToken ? (
                                      `Total Bill`
                                    ) : (
                                      <IntlMessages id='dashboard.billingplans.totalbill' />
                                    )}
                                    : {this.state.selectedPkgCurrSymbol}{' '}
                                    {this.state.outletCount <
                                    this.state.registerCount
                                      ? (this.state.outletPriceYearlyPerMonth +
                                          this.state
                                            .registerYearlyPricePerMonth) *
                                        12
                                      : this.state.outletPriceYearlyPerMonth *
                                        12}{' '}
                                    {this.state.isWithoutToken ? (
                                      `annually`
                                    ) : (
                                      <IntlMessages id='dashboard.billingplans.annually' />
                                    )}
                                  </p>
                                </Col>
                              </Row>

                              <div></div>
                            </Card>
                          </div>
                        </Col>

                        <Col
                          lg={12}
                          md={12}
                          sm={12}
                          xs={24}
                          className='dk-flex-promo-1'
                        >
                          <div className='dk-custom-promoadd-card1 dk-flex-promo-1'>
                            <Card
                              title={
                                this.state.isWithoutToken ? (
                                  `Monthly Billing`
                                ) : (
                                  <IntlMessages id='dashboard.billingplans.monthlybilling' />
                                )
                              }
                              style={{
                                textAlign: 'left',
                                display: 'grid'
                              }}
                              className={`${
                                this.state.isSelectedBill == 1
                                  ? 'ant-card-bordered-active'
                                  : ''
                              }`}
                              onClick={() => this.updatedPlanBill(1)}
                            >
                              <Row>
                                <Col md={12}>
                                  <p style={{ fontSize: '13px' }}>
                                    {this.state.isWithoutToken ? (
                                      `Get your bill once a month.`
                                    ) : (
                                      <IntlMessages id='dashboard.billingplans.monthlybillmsg' />
                                    )}
                                  </p>
                                </Col>
                                <Col md={12}>
                                  <h2>
                                    {this.state.selectedPkgCurrSymbol}{' '}
                                    {this.state.outletCount <
                                    this.state.registerCount
                                      ? this.state.outletPricePerMonth +
                                        this.state.registerPricePerMonth
                                      : this.state.outletPricePerMonth}
                                    /mo
                                  </h2>
                                  <p>
                                    {' '}
                                    {this.state.isWithoutToken ? (
                                      `EUR Billed Monthly`
                                    ) : (
                                      <IntlMessages id='dashboard.billingplans.usdbillmonthly' />
                                    )}
                                  </p>
                                </Col>
                              </Row>

                              <div></div>
                            </Card>
                          </div>
                        </Col>
                      </Row>

                      <Divider className='mt-0 mb-4' />

                      <Row className='total-bill d-flex justify-content-between'>
                        <Col md={12}>
                          <h2>
                            {this.state.isWithoutToken ? (
                              `Total Bill`
                            ) : (
                              <IntlMessages id='dashboard.billingplans.totalbill' />
                            )}
                          </h2>
                        </Col>

                        <Col md={6}>
                          <h2>
                            {this.state.selectedPkgCurrSymbol}{' '}
                            {this.state.totalBill}
                            {this.state.isSelectedBill == 1 ? (
                              this.state.isWithoutToken ? (
                                `/mo`
                              ) : (
                                <IntlMessages id='dashboard.billingplans.permo' />
                              )
                            ) : this.state.isWithoutToken ? (
                              `/annum`
                            ) : (
                              <IntlMessages id='dashboard.billingplans.perannum' />
                            )}
                          </h2>
                          <p>
                            {this.state.isWithoutToken ? (
                              `EUR billed`
                            ) : (
                              <IntlMessages id='dashboard.billingplans.usdbilled' />
                            )}{' '}
                            {this.state.billType}
                          </p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Divider className='mt-3 mb-4' />

                  <div className='customizedsolution-wrap'>
                    <div className='cs-wrap-img'>
                    <img src={checklistitemsImg} className='' alt='POS Hardware' />
                    </div>
                    <div className='cs-wrap-cont'>
                      <h2>
                        Want a customized solution? We've got it.
                      </h2>
                      <p>
                        Whether you're stationing your POS on the counter or
                        walking around with an iPad, {REACT_APP_BUS_FIRST_NAME}{' '}
                        will help you find the right retail customized setup.
                        Your perfect wireless experience awaits.
                      </p>
                      <Button type='primary' size='large'
                          onClick={() => {
                            const { dispatch } = this.props
                            dispatch(loadShowContactUs(true))
                          }} >
                          Talk to Us
                        </Button>
                    </div>
                  </div>

                  <Divider className='mt-3 mb-4' />

                  <Row justify='center' className='mb-4'>
                    <Col>
                      <Button
                        className=''
                        type='primary'
                        onClick={() => {
                          const { dispatch } = this.props
                          if (this.state.isWithoutToken) {
                            if (this.state.isFreeTrial) {
                              window.location.href = '/signup'
                            } else {
                              window.location.href = `/store/request/${this.state.outletCount}/${this.state.registerCount}/${this.state.packageId}/${this.state.isSelectedBill}`
                            }
                          } else {
                            dispatch(loadPaymentTypesModalShow(true))
                          }
                          // this.setState({ visible: true });
                        }}
                        // block
                        size='large'
                      >
                        {this.state.isWithoutToken ? (
                          `${
                            this.state.isFreeTrial
                              ? 'Start your free trial'
                              : 'Subscribe'
                          }`
                        ) : (
                          <IntlMessages id='dashboard.billingplans.btncreditcarddetails' />
                        )}
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </Col>

            <ContactUsDialog
              countriesObject={this.state.countries}
              businessObjects={this.state.bTypes}
            />
            <PaymentStatusModal />
            <PaymentTypesModal
              noOfOutlet={this.state.outletCount}
              noOfReg={this.state.registerCount}
              id={this.state.packageId}
              periodFreq={this.state.isSelectedBill}
              mode={PAY_PAY_MODE.SUBSCRIPTION} // 1 for subscription
            />
          </Row>
        </Spin>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    locale: state.settings.locale.locale
  }
  //consloe.log(state.settings.locale);
}

export default connect(mapStateToProps)(BillingPlans)
